// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__M-LXE","toggleWrap":"styles_toggleWrap__1j1eN","content":"styles_content__11tXB","selectAreaCode":"styles_selectAreaCode__1eg6W"};